import React, { PropTypes } from 'react';

import EventLogo from '../EventLogo';

import { alignCenter, header, container, title as titleStyle } from './styles.module.css';

/**
 * Generic page header presentational component.
 */
const PageHeader = ({
  className,
  description,
  logo,
  title,
}) => (
  <div className={[container, className].join(' ')}>
    <div className={header}>
      {logo && <EventLogo logo={logo} className={alignCenter} />}
      <h1 className={titleStyle}>{title}</h1>
      {description
        /* eslint-disable max-len, react/no-danger */ &&
        <div dangerouslySetInnerHTML={{ __html: description }} /> /* eslint-enable */}
    </div>
  </div>
);

PageHeader.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /*
   * Organiser/collection description.
   */
  description: PropTypes.string,
  /*
   * String for logo to be displayed.
   */
  logo: PropTypes.string,
  /*
   * Name of collection or organiser.
   */
  title: PropTypes.string.isRequired,
};

PageHeader.defaultProps = {
  className: '',
  description: undefined,
  logo: undefined,
};

export default PageHeader;



// WEBPACK FOOTER //
// ./app/src/components/PageHeader/index.jsx